import React, { createContext, useEffect, useState } from "react";
import { getTheme, setStoreTheme } from "../utils/manageStore";

const ThemeContext = createContext();

const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(getTheme());
  const [showMenu, setShowMenu] = useState(window.innerWidth > 768);

  const toggleTheme = () => {
    setTheme(theme === "light" ? "dark" : "light");
    setStoreTheme(theme === "light" ? "dark" : "light");
  };

  const toggleMenu = () => {
    setShowMenu(showMenu === true ? false : true);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setShowMenu(false);
      } else {
        setShowMenu(true);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, showMenu, toggleMenu }}>
      {children}
    </ThemeContext.Provider>
  );
};

export { ThemeContext, ThemeProvider };
